import { render, staticRenderFns } from "./xu.vue?vue&type=template&id=5862b764&scoped=true&"
import script from "./xu.vue?vue&type=script&lang=js&"
export * from "./xu.vue?vue&type=script&lang=js&"
import style0 from "./xu.vue?vue&type=style&index=0&id=5862b764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862b764",
  null
  
)

export default component.exports